import React, { lazy, useEffect } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation
} from 'react-router-dom';
import Home from './pages/Home/Home';
import PrivateCloud from './pages/PrivateCloud/PrivateCloud';
import SecureTeleworking from './pages/InfraCloud/SecureTeleworking';
import MigrationCloud from './pages/MigrationCloud/MigrationCloud';
import DevSecOps from './pages/DevSecOps/DevSecOps';
import AdminCloud from './pages/AdminCloud/AdminCloud';
import AppCloud from './pages/AppCloud/AppCloud';
import IncidentCyber from './pages/IncidentCyber/IncidentCyber';
import AuditCyber from './pages/AuditCyber/AuditCyber';
import CloudCyber from './pages/AuditCyber/AuditCyber';
import DataCyber from './pages/DataCyber/DataCyber';
import Legal from './pages/Legal/Legal';
import FormationEntra from './pages/FormationEntra/FormationEntra';
import FormationCloudFundamentals from './pages/FormationAzureFundamentals/FormationAzureFundamentals';
import FormationAi from './pages/FormationAi/FormationAi';
import LabAI from './pages/LabAI/LabAI';
import FormationAzureAdmin from './pages/FormationAzureAdmin/FormationAzureAdmin';
import CyberNewsList from './components/CyberNews/CyberNewsList';
import CyberNewsArticle from './components/CyberNews/CyberNewsArticle';
import CyberNewsExploitList from './components/CyberNews/CyberNewsExploitList';
import CyberNewsQuantumList from './components/CyberNews/CyberNewsQuantumList';
import CyberNewsEventList from './components/CyberNews/CyberNewsEventList';
import VdiUserCase from './pages/VdiUseCase/VdiUserCase';
import VatpCyber from './pages/VatpCyber/VatpCyber';
import i18n from './i18n/i18n';
import AVDAssessment from './pages/AVDAssessment/AVDAssessment';
import OfferMigration1 from './pages/OfferMigration1/OfferMigration1';

const CyberNews = lazy(() => import('./pages/CyberNews/CyberNews'));

const RedirectFrenchRoutes: React.FC = () => {
  const location = useLocation();
  const newPath = location.pathname.substring(3);
  return <Navigate to={newPath} replace />;
};

const getDefaultLanguage = () => {
  const browserLang = navigator.language.split('-')[0];
  return ['fr', 'en'].includes(browserLang) ? browserLang : 'fr';
};

const AppRoutes: React.FC = () => {
  const defaultLanguage = getDefaultLanguage();

  const renderFrenchRoutes = () => (
    <>
      <Route path="/" element={<Home />} />
      <Route path="/privatecloud" element={<PrivateCloud />} />
      <Route path="/cloudmigration" element={<MigrationCloud />} />
      <Route path="/cloudmigration/migration-assessment" element={<OfferMigration1 />} />
      <Route path="/devsecops" element={<DevSecOps />} />
      <Route path="/cloudadmin" element={<AdminCloud />} />
      <Route path="/secureteleworking" element={<SecureTeleworking />} />
      <Route path="/cloudappdeployment" element={<AppCloud />} />
      <Route path="/cyberincident" element={<IncidentCyber />} />
      <Route path="/cyberaudit" element={<AuditCyber />} />
      <Route path="/cybercloud" element={<CloudCyber />} />
      <Route path="/sentinel" element={<DataCyber />} />
      <Route path="/vatp" element={<VatpCyber />} />
      <Route path="/academy/securitycloud" element={<FormationEntra />} />
      <Route path="/academy/cloudfundamentals" element={<FormationCloudFundamentals />} />
      <Route path="/academy/ai" element={<FormationAi />} />
      <Route path="/academy/azureadmin" element={<FormationAzureAdmin />} />
      <Route path="/ai/lab" element={<LabAI />} />
      <Route path="/cyberguerre" element={<CyberNews />}>
        <Route index element={<CyberNewsList />} />
        <Route path="exploits" element={<CyberNewsExploitList />} />
        <Route path="quantique" element={<CyberNewsQuantumList />} />
        <Route path="event" element={<CyberNewsEventList />} />
        <Route path=":category/:slug" element={<CyberNewsArticle />} />
      </Route>
      <Route path="/vdi" element={<VdiUserCase />} />
      <Route path="/avd-assessment" element={<AVDAssessment />} />
      <Route path="/legal" element={<Legal />} />
    </>
  );

  const renderEnglishRoutes = () => (
    <>
      <Route path="/en" element={<Home />} />
      <Route path="/en/privatecloud" element={<PrivateCloud />} />
      <Route path="/en/cloudmigration" element={<MigrationCloud />} />
      <Route path="/en/cloudmigration/migration-assessment" element={<OfferMigration1 />} />
      <Route path="/en/devsecops" element={<DevSecOps />} />
      <Route path="/en/cloudadmin" element={<AdminCloud />} />
      <Route path="/en/secureteleworking" element={<SecureTeleworking />} />
      <Route path="/en/cloudappdeployment" element={<AppCloud />} />
      <Route path="/en/cyberincident" element={<IncidentCyber />} />
      <Route path="/en/cyberaudit" element={<AuditCyber />} />
      <Route path="/en/cybercloud" element={<CloudCyber />} />
      <Route path="/en/sentinel" element={<DataCyber />} />
      <Route path="/en/vatp" element={<VatpCyber />} />
      <Route path="/en/academy/securitycloud" element={<FormationEntra />} />
      <Route path="/en/academy/cloudfundamentals" element={<FormationCloudFundamentals />} />
      <Route path="/en/academy/ai" element={<FormationAi />} />
      <Route path="/en/academy/azureadmin" element={<FormationAzureAdmin />} />
      <Route path="/en/ai/lab" element={<LabAI />} />
      <Route path="/en/cyberguerre" element={<CyberNews />}>
        <Route index element={<CyberNewsList />} />
        <Route path="exploits" element={<CyberNewsExploitList />} />
        <Route path="quantique" element={<CyberNewsQuantumList />} />
        <Route path="event" element={<CyberNewsEventList />} />
        <Route path=":category/:slug" element={<CyberNewsArticle />} />
      </Route>
      <Route path="/en/legal" element={<Legal />} />
      <Route path="/en/vdi" element={<VdiUserCase />} />
      <Route path="/en/avd-assessment" element={<AVDAssessment />} />
    </>
  );

  useEffect(() => {
    const handleLanguageChange = () => {
      const path = window.location.pathname;
      if (path.startsWith('/en')) {
        i18n.changeLanguage('en');
      } else {
        i18n.changeLanguage('fr');
      }
    };

    handleLanguageChange();
    window.addEventListener('popstate', handleLanguageChange);
    return () => window.removeEventListener('popstate', handleLanguageChange);
  }, []);

  return (
    <Router>
      <Routes>
        {renderFrenchRoutes()}
        {renderEnglishRoutes()}

        <Route path="/fr" element={<Navigate to="/" replace />} />
        <Route path="/fr/*" element={<RedirectFrenchRoutes />} />

        <Route path="/en/*" element={<Home />} />

        <Route path="*" element={<Home />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
